import React from 'react';
import { COMPARATIVE_INCOME_STATEMENT_FEATURE_NAME } from 'components/financials/comparative-income-statement/constants';
import { BALANCE_SHEET_TITLE } from 'components/financials/balanceSheet/constants';
import { CROSSTAB_TITLE } from 'components/financials/crosstab/CrosstabConstants';
import Navbar from 'components/style/Navbar';
import { RouteUrls } from 'routes/RouteConstants';
import {
    hasBalanceSheetEnabled,
    hasCrosstabEnabled,
    hasVarianceReportDashboardEnabled,
} from 'state/user/selectors';
import { connect } from 'react-redux';
import { VARIANCE_REPORTING_TITLE } from 'components/financials/variance-report-status/constants';
import { usePermissions, AppFeaturePermissions } from 'contexts';

const FinancialsNavbar = ({
    hasBalanceSheet,
    hasCrosstab,
    hasVarianceReports,
}) => {
    const { featurePermissions } = usePermissions();

    const showBalanceSheet = featurePermissions?.includes(
        AppFeaturePermissions.BalanceSheet
    );
    const showCrosstab = featurePermissions?.includes(
        AppFeaturePermissions.Crosstab
    );
    const showVarianceReports = featurePermissions?.includes(
        AppFeaturePermissions.VarianceReporting
    );
    const showIncomeStatement = featurePermissions?.includes(
        AppFeaturePermissions.IncomeStatement
    );

    return (
        <Navbar
            data-test="financials-navbar"
            style={{ top: '0px' }}
            items={[
                showIncomeStatement && {
                    title: COMPARATIVE_INCOME_STATEMENT_FEATURE_NAME,
                    url: RouteUrls.FINANCIALS_COMPARATIVE_INCOME_STATEMENT,
                },
                hasBalanceSheet &&
                    showBalanceSheet && {
                        title: BALANCE_SHEET_TITLE,
                        url: RouteUrls.FINANCIALS_BALANCE_SHEET,
                    },
                hasCrosstab &&
                    showCrosstab && {
                        title: CROSSTAB_TITLE,
                        url: RouteUrls.FINANCIALS_CROSSTAB,
                    },
                hasVarianceReports &&
                    showVarianceReports && {
                        title: VARIANCE_REPORTING_TITLE,
                        url: RouteUrls.FINANCIALS_VARIANCE_REPORT_STATUS,
                    },
            ]}
        />
    );
};

const mapState = (state) => ({
    hasBalanceSheet: hasBalanceSheetEnabled(state),
    hasCrosstab: hasCrosstabEnabled(state),
    hasVarianceReports: hasVarianceReportDashboardEnabled(state),
});

export default connect(mapState)(FinancialsNavbar);
